import { useMemo } from 'react'
import { useFirestoreQuery } from '../../firebase/useFirestore'

/**
 * De naam van elk effect van deze organisatie, per effect-ID.
 *
 * Nodig omdat de oudste doelen van een deelnemer geen eigen titel hebben: zo'n
 * doel wás één effect, en heet dus naar dat effect (`goalTitle`). Eén plek, zodat
 * de doelentabel en de doelenkaart niet elk hun eigen opzoeklijst bouwen.
 *
 * Geeft `null` zolang de effecten laden: dan is een lege titel nog geen
 * 'zonder titel'.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {{ enabled?: boolean }} [options] - `enabled: false` opent geen query
 *   (de openbare rapportage, die de namen van de server krijgt — ADR-022)
 * @returns {Object<string, string>|null}
 */
const useEffectNameById = ({ enabled = true } = {}) => {
    // Zelfde query als PersonaGoalDetail (useFirestoreOrderBy); Firestore deelt één listener per query.
    const effects = useFirestoreQuery('OutputEffects', { orderBy: ['Position', 'asc'], enabled })

    return useMemo(() => {
        if (!Array.isArray(effects)) return null
        return Object.fromEntries(effects.map((effect) => [effect.ID, effect.Effect]))
    }, [effects])
}

export default useEffectNameById
